import { render, staticRenderFns } from "./employeeTransferAction.vue?vue&type=template&id=2bd48574&scoped=true"
import script from "./employeeTransferAction.vue?vue&type=script&lang=js"
export * from "./employeeTransferAction.vue?vue&type=script&lang=js"
import style0 from "./employeeTransferAction.vue?vue&type=style&index=0&id=2bd48574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd48574",
  null
  
)

export default component.exports